export default "__VITE_ASSET__DEx6hCXp__"